import React, { useState } from "react";

export default function MakeYourOwnDataset() {
  const [name, setName] = useState("");
  const [selectedAnimal, setSelectedAnimal] = useState("");
  const [selectedFood, setSelectedFood] = useState("");
  const [dataset, setDataset] = useState([]);

  const animalOptions = ["🐘 Elephant", "🐱 Cat", "🐶 Dog", "🐰 Bunny"];
  const foodOptions = ["🍕 Pizza", "🍎 Apple", "🍪 Cookie", "🥕 Carrot"];

  const styles = {
    body: {
      fontFamily: "sans-serif",
      padding: "2rem",
      maxWidth: 800,
      margin: "auto",
      background: "#f9fafb",
    },
    h1: {
      textAlign: "center",
      fontSize: "2rem",
    },
    input: {
      padding: 10,
      margin: 5,
      borderRadius: 8,
      border: "1px solid #ccc",
      width: "100%",
      boxSizing: "border-box",
    },
    btn: {
      padding: 10,
      margin: 5,
      borderRadius: 8,
      border: "none",
      cursor: "pointer",
      backgroundColor: "#38a169",
      color: "white",
      userSelect: "none",
    },
    btnHover: {
      backgroundColor: "#2f855a",
    },
    choicesBtn: {
      backgroundColor: "#e2e8f0",
      margin: 5,
      cursor: "pointer",
      border: "none",
      padding: 10,
      borderRadius: 8,
      userSelect: "none",
    },
    choicesBtnSelected: {
      backgroundColor: "#90cdf4",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "1rem",
    },
    thtd: {
      border: "1px solid #ccc",
      padding: 8,
      textAlign: "center",
    },
    th: {
      backgroundColor: "#edf2f7",
    },
    deleteBtn: {
      color: "red",
      cursor: "pointer",
      background: "none",
      border: "none",
      fontSize: "1rem",
    },
  };

  function addRow() {
    if (!name.trim() || !selectedAnimal || !selectedFood) {
      alert("Please fill in all fields!");
      return;
    }
    setDataset((prev) => [
      ...prev,
      { name: name.trim(), animal: selectedAnimal, food: selectedFood },
    ]);
    setName("");
    setSelectedAnimal("");
    setSelectedFood("");
  }

  function deleteRow(index) {
    setDataset((prev) => prev.filter((_, i) => i !== index));
  }

  function downloadCSV() {
    const headers = ["Name", "Favorite Animal", "Favorite Food"];
    const rows = dataset.map((obj) => [obj.name, obj.animal, obj.food]);
    const csvContent =
      [headers, ...rows].map((e) => e.join(",")).join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "my_dataset.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function refreshDataset() {
    setDataset([]);
    setName("");
    setSelectedAnimal("");
    setSelectedFood("");
  }

  return (
    <div style={styles.body}>
      <h1 style={styles.h1}>📊 Make Your Own Dataset</h1>

      <div>
        <input
          type="text"
          placeholder="Your Name"
          value={name}
          style={styles.input}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div>
        <p>Pick Your Favorite Animal:</p>
        <div>
          {animalOptions.map((animal) => (
            <button
              key={animal}
              onClick={() => setSelectedAnimal(animal)}
              style={{
                ...styles.choicesBtn,
                ...(selectedAnimal === animal
                  ? styles.choicesBtnSelected
                  : {}),
              }}
            >
              {animal}
            </button>
          ))}
        </div>
      </div>

      <div>
        <p>Pick Your Favorite Food:</p>
        <div>
          {foodOptions.map((food) => (
            <button
              key={food}
              onClick={() => setSelectedFood(food)}
              style={{
                ...styles.choicesBtn,
                ...(selectedFood === food ? styles.choicesBtnSelected : {}),
              }}
            >
              {food}
            </button>
          ))}
        </div>
      </div>

      <button style={styles.btn} onClick={addRow}>
        Add Row
      </button>
      <button
        style={{ ...styles.btn, backgroundColor: "#718096" }}
        onClick={refreshDataset}
      >
        🔄 Start New Dataset
      </button>

      {dataset.length > 0 && (
        <>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{ ...styles.thtd, ...styles.th }}>Name</th>
                <th style={{ ...styles.thtd, ...styles.th }}>Favorite Animal</th>
                <th style={{ ...styles.thtd, ...styles.th }}>Favorite Food</th>
                <th style={{ ...styles.thtd, ...styles.th }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {dataset.map(({ name, animal, food }, i) => (
                <tr key={i}>
                  <td style={styles.thtd}>{name}</td>
                  <td style={styles.thtd}>{animal}</td>
                  <td style={styles.thtd}>{food}</td>
                  <td style={styles.thtd}>
                    <button
                      style={styles.deleteBtn}
                      onClick={() => deleteRow(i)}
                      aria-label={`Delete row for ${name}`}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* <button style={styles.btn} onClick={downloadCSV}>
            Download Dataset (CSV)
          </button> */}
        </>
      )}
    </div>
  );
}
